import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NetworkHelper } from '@wm-libs/core';
import { environment } from '../../../environments/environment';
import { Session } from '../interfaces/sessions.interface';

@Injectable({
  providedIn: 'root',
})
export class ActiveSessionsService {
  readonly apiUrl = `${environment.poolApi}/user/sessions`;

  constructor(private networkHelper: NetworkHelper) {}

  getActiveSessions(): Observable<Session[]> {
    return this.networkHelper.get<Session[]>(`${this.apiUrl}`);
  }

  deleteActiveSessions(keepCurrent?: boolean): Observable<Session[]> {
    const params = keepCurrent ? { keepCurrent: true } : {};
    return this.networkHelper.delete<Session[]>(`${this.apiUrl}`, params);
  }

  deleteSpecificSession(sessionId: number): Observable<Session[]> {
    return this.networkHelper.delete<Session[]>(`${this.apiUrl}/${sessionId}`);
  }
}
